export const en = {
  retry: 'Retry'
};

export type Translations = typeof en;
